<div class="modal-body no-modal-bottom" id="map-modal">
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
  <map-component *ngIf="mapConfig" [mapConfig]="mapConfig" [options]="options"></map-component>
</div>
